// import ChevronLeft from '@mui/icons-material/ChevronLeft';
// import ChevronRight from '@mui/icons-material/ChevronRight';
// import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import CopyToClipboardButton from '../../common/CopyToClippboardButton';
// import { Chip } from "@mui/material";
import * as React from "react";
import { useEffect } from "react";
import {
    Datagrid,
    List,
    TextField,
    useRefresh,
    useRecordContext,
    DateField
} from 'react-admin';
import { Link } from "@mui/material";


const IdField = () => {
    const record = useRecordContext();
    return record && record.id ?
        <div className="data-cell__copy-to-clipboard"><span>{record.id}</span><CopyToClipboardButton string source={record.id} className="launch-link" /></div> : null;
}
IdField.defaultProps = { label: 'Id' };

const UserIdField = () => {
    const record = useRecordContext();
    return record && record.id ?
        <div className="data-cell__copy-to-clipboard"><span>{record.userId}</span><CopyToClipboardButton string source={record.userId} className="launch-link" /></div> : null;
}
UserIdField.defaultProps = { label: 'UserId' };

const PriceField = () => {
    const record = useRecordContext();
    return record && record.id ?
        <div className="data-cell__copy-to-clipboard"><span>${record.price}</span></div> : null;
}
PriceField.defaultProps = { label: 'Price' };

const UserField = () => {
    const record = useRecordContext();
    const { userName, userId } = record;
    return record ?
        <Link href={`/#/users/${userId}/show/`} className="launch-link" >
            {userName || userId}
        </Link> : null;
}
UserField.defaultProps = { label: 'User' };

const AuthorField = () => {
    const record = useRecordContext();
    const { authorName, authorId } = record;
    return record ?
        <Link href={`/#/users/${authorId}/show/`} className="launch-link" >
            {authorName || authorId}
        </Link> : null;
}
AuthorField.defaultProps = { label: 'Author' };

const EventField = () => {
    const record = useRecordContext();
    const { eventName, eventId } = record;
    return record ?
        <Link href={`/#/posts/${eventId}/show/`} className="launch-link" >
            {eventName || eventId}
        </Link> : null;
}
EventField.defaultProps = { label: 'Event' };

export const TransactionsList = (props) => {
    const refresh = useRefresh();
    const refreshInterval = 12 * 60 * 60 * 1000; // 30 seconds

    useEffect(() => {
        if (refreshInterval && refreshInterval > 0) {
            const interval = setInterval(refresh, refreshInterval);
            return () => clearInterval(interval);
        }
    }, [refresh, refreshInterval]);

    // const listFilters = [
    //     <SearchInput
    //         source="search_by"
    //         alwaysOn
    //         fullWidth
    //         sx={{
    //             '& ': {
    //                 width: '360px'
    //             }
    //         }}
    //         placeholder='Search user'
    //     />,
    //     // <QuickFilter
    //     //     source="administrator"
    //     //     label="Creator"
    //     //     defaultValue={true}
    //     // />,
    // ];

    const CustomEmpty = () => <p className='empty-text'>No transactions</p>;

    return (
        <List
            {...props}
            // filters={listFilters}
            perPage={50}
            sort={{ field: "date", order: "DESC" }}
            pagination={false}
            filterDefaultValues={{ nav_direction: 'next', nav_at: 0, }}
            actions={null}
        >
            <Datagrid
                optimized
                rowClick="show"
                bulkActionButtons={false}
                empty={<CustomEmpty />}
            >
                <IdField source="id" sortable={false} />
                <TextField source="type" sortable={false} />
                <TextField source="status" sortable={false} />
                <TextField source="website" sortable={false} />
                <EventField source="eventId" sortable={false} />
                <PriceField source="price" sortable={false} />
                <UserField source="userId" sortable={false} />
                <AuthorField source="authorId" sortable={false} />
                <DateField source="date" showTime={true} sortable={false} locales="en-US" />
                {/* <DateField source="startDate" showTime={true} sortable={false} locales="en-US" />
                <DateField source="expireDate" showTime={true} sortable={false} locales="en-US" /> */}
            </Datagrid>
        </List>
    );
};
